<template>
  <a-dropdown
    ><span class="current-sort">
      <div class="sort-img"></div>
      <span class="span">{{ currentSort.name }}</span></span
    >
    <template #overlay>
      <ul class="upload_dropdown">
        <li @click="changeSort(item)" v-for="item in sortConfig" :key="item.key">
          {{ item.name }}
        </li>
      </ul>
    </template>
  </a-dropdown>
</template>

<script>
import { ref } from 'vue';

export default {
  emits: ['sort'],
  props: {
    rlogKey: String,
  },
  setup(props, context) {
    const currentSort = ref({ name: '文件名A-Z', key: 'alphabeticIncrease' });
    const sortConfig = [
      {
        key: 'alphabeticIncrease',
        name: '文件名A-Z',
      },
      {
        key: 'alphabeticDecrease',
        name: '文件名Z-A',
      },
      {
        key: 'timeIncrease',
        name: '新文件在后',
      },
      {
        key: 'timeDecrease',
        name: '新文件在前',
      },
    ];
    function changeSort(sortItem) {
      window._rlog.push(['_trackEvent', `${props.rlogKey}_${sortItem.key}`]);
      currentSort.value = sortItem;
      context.emit('sort', {
        sortKey: sortItem.key,
      });
    }

    return {
      sortConfig,
      changeSort,
      currentSort,
    };
  },
};
</script>

<style lang="scss" scoped>
.sort-img {
  width: 24px;
  height: 24px;
  background: url('./imgs/sort-icon.png') center center no-repeat;
  background-size: 100% 100%;
}
.current-sort {
  cursor: pointer;
  position: absolute;
  line-height: 17px;
  bottom: 10px;
  right: 130px;
  color: #212327;
  font-size: 15px;
  display: flex;
  align-items: center;
}
.upload_dropdown {
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 0;
  box-shadow: 0px 16px 30px rgba(0, 0, 0, 0.08);
  li {
    height: 42px;
    width: 180px;
    cursor: pointer;
    padding-left: 20px;
    line-height: 42px;
    &:hover {
      background: $grey4;
    }
  }
}
</style>
